import APIConfig from '../apiconfig';

export const shouldShowIPRegions = () => APIConfig.showIPRegions;
